import React from 'react'
import PageWrapper from '../Components/Other/PageWrapper'
import { useEffect, useState } from 'react';
import PageBanner from '../Components/Other/PageBanner'
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment'
import { CommonApiFun } from '../Redux/Action/index'
import { routes } from '../MainPage'
import { useNavigate } from "react-router-dom";
function Blog(props) {
    const dispatch = useDispatch()
    let navigate = useNavigate();
    var blogArr = useSelector((state) => state.blogArr)
    const [isLoading, setIsloading] = useState(true)
    useEffect(() => {
        var data = { action: "blogs" }
        //http://192.169.143.211/~devapp/ansh_clinic/admin/api/Api_controller/post
        dispatch(CommonApiFun("api/Api_controller/post", JSON.stringify(data))).then((res) => {
            dispatch({ type: 'BLOGS_DATA', payload: res.data })
            setIsloading(false)
        }).catch((e) => {

        })
    }, [])
    return (
        <PageWrapper className={"blog-page"}>
            <div className="pageWrapper">
                <PageBanner pageName={"Our Articles"}></PageBanner>
                <div className="MainContent">
                    <div className="container">
                        <div className="row news-wrapper article-grid">
                            <div className="news_wrap">
                                <div className="news_box">
                                    {(blogArr.length == 0 && isLoading) ? <div className='loader-box'><div className="loader"></div></div>
                                        : blogArr.length == 0 &&
                                        <div class="not_found">
                                            <span><img src={require('../img/emptyData.png')} /></span><p>No article Found</p>
                                        </div>}
                                    {
                                        blogArr.map((item, index) => {
                                            return (
                                                <div className="col-mb-12 col-xs-6 col-4 article-item" key={index}>
                                                    <div className="news_inner" onClick={() => navigate(routes.blog + '/info', { state: item })}>
                                                        <a href="javascript:void(0)">
                                                            <img src={item.image} />
                                                        </a>
                                                        <span className="article-date">{moment(item.created_date).format("MMM Do, YY")}</span>
                                                        <h5>
                                                            <a href="javascript:void(0)">
                                                                {item.title}
                                                            </a>
                                                        </h5>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </PageWrapper>
    );
}

export default Blog;